import { useState } from 'react';
import { C } from '../data';
import { supabase } from '../supabase';
import { useAuth } from '../context/AuthContext';
import { isValidPassword, PASSWORD_HINT } from '../utils/validators';

export default function ResetPasswordPage({ onGoHome }) {
  const { clearPasswordRecovery } = useAuth();
  const [newPw, setNewPw] = useState('');
  const [newPw2, setNewPw2] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!isValidPassword(newPw)) { setError(`비밀번호는 ${PASSWORD_HINT}여야 합니다.`); return; }
    if (newPw !== newPw2) { setError('비밀번호가 일치하지 않습니다.'); return; }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password: newPw });
    setLoading(false);
    if (error) { setError('변경 실패: ' + error.message); return; }
    clearPasswordRecovery();
    setDone(true);
  };

  const goHome = () => { clearPasswordRecovery(); onGoHome(); };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ width:'100%', maxWidth:400, padding:'40px 32px' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <span style={{ fontFamily:"'DM Serif Display',serif", fontSize:20, letterSpacing:4 }}>UNDERLOOKED</span>
        </div>

        {done ? (
          <div style={{ textAlign:'center' }}>
            <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, color:'#3D8B5C', lineHeight:2, marginBottom:24 }}>
              비밀번호가 변경되었습니다.<br/>새 비밀번호로 다시 로그인해 주세요.
            </p>
            <button onClick={goHome} style={{ padding:'12px 32px', background:C.ink, color:C.bg, border:'none', cursor:'pointer', fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:11, letterSpacing:3 }}>
              홈으로
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:C.muted, textAlign:'center', marginBottom:8, lineHeight:1.8 }}>
              새로 사용할 비밀번호를 입력해 주세요.
            </p>
            <div>
              <label className="adm-label">새 비밀번호</label>
              <input className="adm-input" type="password" placeholder={PASSWORD_HINT} value={newPw} onChange={e => setNewPw(e.target.value)} required />
            </div>
            <div>
              <label className="adm-label">새 비밀번호 확인</label>
              <input className="adm-input" type="password" placeholder="다시 입력" value={newPw2} onChange={e => setNewPw2(e.target.value)} required />
            </div>
            {error && <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:'#C94040', textAlign:'center' }}>{error}</p>}
            <button type="submit" disabled={loading} style={{
              marginTop:4, padding:'13px 0', background:C.ink, color:C.bg, border:'none', cursor:'pointer',
              fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:11, letterSpacing:3,
              opacity:loading?.6:1, transition:'opacity .18s',
            }}>{loading ? '변경 중...' : '비밀번호 변경'}</button>
          </form>
        )}
      </div>
    </div>
  );
}
